<button class="btn btn-primary mb-1" [disabled]="isLocked" (click)="manualShowTicket()"  #button>
    <span class="element-text">{{ 'console.manual-show' | translate }}</span>
</button>
